// RecentTickets.js
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assests/css/admin/Help&Support/RecentTickets/RecentTickets.css';

const RecentTickets = ({ onViewAll }) => {
  const { baseUrl } = useContext(AppContext); // adminToken ka naam apne AppContext ke hisab se adjust karo

  const [allTickets, setAllTickets] = useState([]);
  const [loading, setLoading]       = useState(false);
  const [visibleTickets, setVisibleTickets] = useState(5);

  const fetchTickets = () => {
    if (!baseUrl) return;
    setLoading(true);
   axios
  .get(`${baseUrl}/admin/HelpandSupport/viewAllHelpsupport`)
      .then((res) => {
        if (res.data.success) setAllTickets(res.data.tickets || []);
        else setAllTickets([]);
      })
      .catch((err) => {
        console.error('viewAllHelpsupport error:', err);
        setAllTickets([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchTickets(); }, [baseUrl]);

  const handleViewAll = () => {
    if (visibleTickets < allTickets.length) {
      setVisibleTickets(visibleTickets + 2);
    } else {
      onViewAll();
    }
  };

  const getStatusClass = (status) => {
    return `AdminTicket-status AdminTicket-status-${(status || '').toLowerCase()}`;
  };

  const displayedTickets = allTickets.slice(0, visibleTickets);

  return (
    <div className="AdminTicket-section">
      <div className="AdminTicket-header">
        <h2 className="AdminTicket-title">Recent Support Tickets</h2>
        <button className="AdminTicket-view-all" onClick={handleViewAll}>
          {visibleTickets < allTickets.length ? `View All (${allTickets.length - visibleTickets} more)` : 'View All'}
        </button>
      </div>
      <div className="AdminTicket-table-container">
        <table className="AdminTicket-table">
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>SUBJECT</th>
              <th>CATEGORY</th>
              <th>STATUS</th>
              <th>LAST UPDATED</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Loading...</td></tr>
            ) : displayedTickets.length === 0 ? (
              <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No tickets found</td></tr>
            ) : (
              displayedTickets.map((ticket, index) => (
                <tr
                  key={ticket.id}
                  style={{
                    animation: index >= visibleTickets - 2 ? 'AdminTicket-fadeIn 0.5s ease' : 'none'
                  }}
                >
                  <td className="AdminTicket-id">#{ticket.id}</td>
                  <td>{ticket.subject}</td>
                  <td>{ticket.category}</td>
                  <td>
                    <span className={getStatusClass(ticket.status)}>
                      {(ticket.status || '').toUpperCase()}
                    </span>
                  </td>
                  <td>{ticket.created_at ? new Date(ticket.created_at).toLocaleDateString() : 'N/A'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentTickets;